export enum MemberType {
  USER = "USER",
  ADMIN = "ADMIN",
}

export enum MemberAuthType {
  GOOGLE = "GOOGLE",
  GITHUB = "GITHUB",
  TELEGRAM = "TELEGRAM",
}

export enum MemberStatus {
  ACTIVE = "ACTIVE",
  BLOCK = "BLOCK",
  DELETE = "DELETE",
}
